import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminRoutes } from './pages/admin/admin-routes';
import { AdminComponent } from './pages/admin/admin.component';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

const routes: Routes = [
  {
    path: 'login', component: LoginComponent,
  },
  {
    path: 'admin',
    component: AdminComponent,
    children: AdminRoutes
  },
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {
    path: '**', component: NotFoundComponent,
    data: {
      breadcrumb: '404'
    },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
